import { apiConstants } from "../../../constants/apiConstants"
import { staticDataService } from "../../../services/staticDataService"
import { schoolSubjectsService } from "../../../services/schoolSubjectsService"
import { TUTOR_DS_GAVE_UP } from "../../actions/tutorDs"
import { isServedFor } from "../../../../featureFlags/tutorDsFF"

// ** Initial State
const initialState = {
    challenge_templates: [],
    activity_templates: [],
    school_subjects: [],
    challenge_intensity_levels: [],
    trial_static_data: {},
    // La dernière lecture de `static-data` a échoué (500, réseau) : posé à l'échec, effacé à la
    // réussite. Gardé ici et pas dans la tranche d'api, qui oublie l'erreur à la requête suivante :
    // l'attente de l'interrupteur du tuteur le lit (`selectTutorDsReading`). Jamais persisté.
    lastReadingFailed: false,
    // Le compte pour lequel la coquille a abandonné l'attente de `tutor_ds` (`tutorDsGaveUp`) :
    // l'interrupteur vaut éteint pour lui, pour tous ses lecteurs à la fois. Une mémoire de la
    // séance : levée par une lecture qui répond pour ce compte, et jamais persistée
    // (`persistedStaticData`) — gardée, elle montrerait l'ancien espace au relancement à qui va
    // avoir le nouveau.
    tutorDsGaveUpFor: null,
}

/**
 * Ce qui se persiste de la tranche : tout, sauf ce qui ne vaut que pour la séance — l'abandon de
 * l'attente, et l'échec de la dernière lecture : gardé, il ferait lire « éteint » sans attendre au
 * compte suivant sur l'appareil, puis basculer à la première lecture réussie.
 */
export function persistedStaticData(state) {
    return state == null
        ? state
        : { ...state, tutorDsGaveUpFor: null, lastReadingFailed: false }
}

export function staticData(state = initialState, action) {
    switch (action.type) {
        case staticDataService.getStaticDataTrial.name + apiConstants._SUCCESS:
            return {
                ...state,
                trial_static_data: action.data,
            }

        case staticDataService.getLoginStaticData.name +
            apiConstants._SUCCESS: {
            // Ce que sert `GET static-data/login` (sans compte), rangé tel quel : une clé absente garde la valeur
            // déjà lue. Lue à chaque écran de connexion : une réponse inchangée (ou vide) garde l'état, et persist
            // n'écrit rien.
            const read = Object.fromEntries(
                Object.entries(action.data ?? {}).filter(
                    ([, value]) => value != null
                )
            )
            if (Object.keys(read).every((key) => state[key] === read[key]))
                return state
            return { ...state, ...read }
        }

        case staticDataService.getStaticData.name + apiConstants._SUCCESS: {
            // Une réponse sans la clé (un backend revenu en arrière) l'efface : l'interrupteur du
            // tuteur (`featureFlags/tutorDsFF.ts`) ne survit pas à une lecture qui ne le redit pas.
            const tutor_ds = action.data?.tutor_ds ?? null
            return {
                ...state,
                ...action.data,
                tutor_ds,
                lastReadingFailed: false,
                // Seule une réponse pour le compte abandonné lève l'abandon (`isServedFor`) : levé par
                // une lecture servie pour un autre, il ferait boucler la coquille.
                tutorDsGaveUpFor: isServedFor(tutor_ds, state.tutorDsGaveUpFor)
                    ? null
                    : state.tutorDsGaveUpFor,
            }
        }

        case staticDataService.getStaticData.name + apiConstants._FAILURE:
            return { ...state, lastReadingFailed: true }

        case TUTOR_DS_GAVE_UP:
            return { ...state, tutorDsGaveUpFor: action.userId ?? null }

        case schoolSubjectsService.getSchoolSubjects.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                school_subjects: action.data,
            }

        default:
            return state
    }
}

export default staticData
